import { StaticImageData } from "next/image";
import amyImage from "@/app/(public)/shared/assets/team/amy.jpeg";
import annaImage from "@/app/(public)/shared/assets/team/anna.jpeg";
import benjiImage from "@/app/(public)/shared/assets/team/benji.jpeg";
import christinaImage from "@/app/(public)/shared/assets/team/christina.jpg";
import emilyImage from "@/app/(public)/shared/assets/team/emily.jpg";
import vinImage from "@/app/(public)/shared/assets/team/vin.png";
import hilaryImage from "@/app/(public)/shared/assets/team/hilary.jpeg";
import rachelImage from "@/app/(public)/shared/assets/team/rachel.jpeg";
import danielImage from "@/app/(public)/shared/assets/team/daniel.png";
import akshajImage from "@/app/(public)/shared/assets/team/akshaj.jpeg";
import rooImage from "@/app/(public)/shared/assets/team/roo.jpg";

/** A Nowadays team member rendered on the public /team page. */
export interface TeamMember {
  id: number;
  name: string;
  role: string;
  image: StaticImageData;
  /** Flag emoji for the member's country; empty string hides the location row. */
  flag: string;
  /** Hometown shown next to the flag, e.g. "Dallas, TX"; empty string hides the row. */
  location: string;
  /** Profile URL opened when the card is activated. */
  linkedin: string;
}

/** The team roster, in display order, shown on the public /team page. */
export const teamMembers: TeamMember[] = [
  {
    id: 1,
    name: "Anna Sun",
    role: "CEO",
    image: annaImage,
    flag: "🇺🇸",
    location: "Canton, MI",
    linkedin: "https://www.linkedin.com/in/annasun19/",
  },
  {
    id: 2,
    name: "Amy Yan",
    role: "COO",
    image: amyImage,
    flag: "🇺🇸",
    location: "Canton, MI",
    linkedin: "https://www.linkedin.com/in/amysunyan/",
  },
  {
    id: 3,
    name: "Vin Bui",
    role: "Founding Engineer",
    image: vinImage,
    flag: "🇺🇸",
    location: "Dallas, TX",
    linkedin: "https://www.linkedin.com/in/vin-bui/",
  },
  {
    id: 4,
    name: "Christina Chen",
    role: "Chief of Staff",
    image: christinaImage,
    flag: "🇺🇸",
    location: "Bethlehem, PA",
    linkedin: "https://www.linkedin.com/in/chrichen/",
  },
  {
    id: 5,
    name: "Emily Zhang",
    role: "Founding Product Engineer",
    image: emilyImage,
    flag: "🇺🇸",
    location: "Irvine, CA",
    linkedin: "https://www.linkedin.com/in/emilyzhang32/",
  },
  {
    id: 6,
    name: "Hilary Le",
    role: "Founding Product Engineer",
    image: hilaryImage,
    flag: "🇺🇸",
    location: "Bay Area, CA",
    linkedin: "https://www.linkedin.com/in/hilaryle/",
  },
  {
    id: 7,
    name: "Rachel Alexander",
    role: "Founding Operator",
    image: rachelImage,
    flag: "🇺🇸",
    location: "Plymouth, MN",
    linkedin: "https://www.linkedin.com/in/rachel-alexander-74a59888/",
  },
  {
    id: 8,
    name: "Daniel Sun",
    role: "AI Engineer",
    image: danielImage,
    flag: "🇺🇸",
    location: "San Diego, CA",
    linkedin: "https://www.linkedin.com/in/math-guy/",
  },
  {
    id: 9,
    name: "Akshaj Kadaveru",
    role: "AI Engineer",
    image: akshajImage,
    flag: "🇺🇸",
    location: "Fairfax, VA",
    linkedin: "https://www.linkedin.com/in/akshaj-kadaveru/",
  },
  {
    id: 10,
    name: "Benji",
    role: "Chief People Officer",
    image: benjiImage,
    flag: "🇺🇸",
    location: "Seattle, WA",
    linkedin: "https://www.linkedin.com/in/benji-yan-239a5a35a/",
  },
  {
    id: 11,
    name: "Roo",
    role: "Pawrty Planner",
    image: rooImage,
    flag: "🇺🇸",
    location: "Seattle, WA",
    linkedin: "https://www.nowadays.ai/",
  },
];
